import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const PHONES = [
  { display: "+91 94440 14561", tel: "+919444014561" },
  { display: "+91 88845 43456", tel: "+918884543456" },
  { display: "+91 93630 14561", tel: "+919363014561" },
  { display: "+91 78128 98967", tel: "+917812898967" },
];
const EMAILS = ["mksikdar@rediffmail.com", "kirtisikdar11@gmail.com"];

export default function Footer() {
  return (
    <footer data-testid="site-footer" style={{ backgroundColor: "#0A1128", color: "#F9F6F0" }}>
      <div className="container-x py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex flex-col gap-1 mb-6">
              <span className="font-serif-display text-3xl" style={{ color: "#F9F6F0", letterSpacing: "0.02em" }}>
                Sikdar &amp; Sikdar
              </span>
              <span className="text-[10px] uppercase" style={{ color: "#C5A059", letterSpacing: "0.32em" }}>
                Advocates
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-md" style={{ color: "rgba(249,246,240,0.7)" }}>
              A boutique practice at the Chennai Bar — disciplined counsel in civil, property,
              service and family matters across the High Courts of Madras, Telangana &amp; Kerala
              and the Armed Forces Tribunals.
            </p>
            <p className="text-xs mt-4" style={{ color: "rgba(249,246,240,0.5)", letterSpacing: "0.08em" }}>
              M.K. Sikdar · Kirti Sikdar
            </p>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase mb-5" style={{ letterSpacing: "0.2em", color: "#C5A059" }}>
              Office
            </h4>
            <ul className="space-y-3 text-sm" style={{ color: "rgba(249,246,240,0.85)" }}>
              <li className="flex gap-3">
                <MapPin size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" style={{ color: "#C5A059" }} />
                <span>
                  No. 31, Palavedu Road,<br/>
                  Mittanamalli, IAF Avadi,<br/>
                  Chennai – 600 055
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Clock size={16} strokeWidth={1.5} style={{ color: "#C5A059" }} />
                <span>Monday – Saturday · 10:00 AM – 7:00 PM</span>
              </li>
              <li className="flex items-center gap-3">
                <Clock size={16} strokeWidth={1.5} style={{ color: "#C5A059" }} />
                <span>Sunday by appointment</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase mb-5" style={{ letterSpacing: "0.2em", color: "#C5A059" }}>
              Direct Contact
            </h4>
            <ul className="space-y-2 text-sm">
              {PHONES.map((p) => (
                <li key={p.tel}>
                  <a href={`tel:${p.tel}`} className="flex items-center gap-3 hover:underline" data-testid={`footer-phone-${p.tel}`} style={{ color: "#F9F6F0" }}>
                    <Phone size={14} strokeWidth={1.5} style={{ color: "#C5A059" }} />
                    {p.display}
                  </a>
                </li>
              ))}
              <li className="pt-2">
                {EMAILS.map((em) => (
                  <a
                    key={em}
                    href={`mailto:${em}`}
                    className="flex items-center gap-3 hover:underline break-all mt-1 first:mt-0"
                    data-testid={`footer-email-${em}`}
                    style={{ color: "#F9F6F0" }}
                  >
                    <Mail size={14} strokeWidth={1.5} style={{ color: "#C5A059" }} />
                    {em}
                  </a>
                ))}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
          style={{ borderTop: "1px solid rgba(249,246,240,0.12)" }}
        >
          <p className="text-xs" style={{ color: "rgba(249,246,240,0.55)", letterSpacing: "0.08em" }}>
            © {new Date().getFullYear()} Sikdar &amp; Sikdar, Advocates. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs" style={{ color: "rgba(249,246,240,0.55)", letterSpacing: "0.18em", textTransform: "uppercase" }}>
            <span>Chennai · India</span>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:underline" style={{ color: "rgba(249,246,240,0.55)" }}>
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
